import type { ReservationRequestProps } from './reservations.types';

const BASE_RESERVATIONS_URL = '/users/reservations';

export const reservationsUrls = {
  reviewReservation: ({ id }: ReservationRequestProps) =>
    `${BASE_RESERVATIONS_URL}/${id}/reviews`,
  cancelReservation: ({ id }: ReservationRequestProps) =>
    `${BASE_RESERVATIONS_URL}/${id}`,
  cancelGuestReservation: () => '/guest_carts',
  notifyCurbsideArrival: ({ id }: ReservationRequestProps) =>
    `${BASE_RESERVATIONS_URL}/${id}/curbside_customer_arrived`,
  reservationOwnerships: ({ id }: ReservationRequestProps) =>
    `${BASE_RESERVATIONS_URL}/${id}/ownerships`,
};
